import React from 'react';
import { RichText, RichTextBlock } from 'prismic-reactjs';

import HorizontalWave from '../../../public/svg/horizontal-wave.svg';
import VerticalWave from '../../../public/svg/vertical-wave.svg';

import { ProcessStages } from './OurStages/ProcessStages';
import { Item, StageKey } from './OurStages/processStage.types';
import { useWindowSize } from '../../../hooks/useWindowSize';
import {
  ProcessProgress,
  ProcessProgressContainer,
  ProcessSubtitle,
  ProcessTitle,
} from './processStage.styles';
import { TitleType } from '../../../models/globalTypes/title';

interface IOurProcess extends TitleType {
  subtitle: Array<RichTextBlock>;
  items: Item[];
  id: string;
  children?: React.ReactNode;
}

export const OurProcess = ({
  title,
  subtitle,
  items,
  id,
  children,
  titleAs,
}: IOurProcess) => {
  const { medium } = useWindowSize();

  const topProcesses = items.filter((item, index) => item.position === 'TOP');
  const bottomProcesses = items.filter(
    (item, index) => item.position === 'BOTTOM'
  );

  return (
    <div
      className="product-design__our-design-process our-design-process"
      id={id}
    >
      <div
        className={`product-design__our-design-process-wrapper ${
          medium ? 'desktop' : 'mobile'
        }`}
      >
        <ProcessTitle as={titleAs}>{title}</ProcessTitle>
        <ProcessSubtitle>{RichText.asText(subtitle)}</ProcessSubtitle>
        <ProcessProgress>
          <ProcessProgressContainer>
            <ProcessStages items={topProcesses} stageKey={StageKey.TOP} />
            {medium ? <HorizontalWave /> : <VerticalWave />}
            <ProcessStages items={bottomProcesses} stageKey={StageKey.BOTTOM} />
          </ProcessProgressContainer>
        </ProcessProgress>
      </div>
      {children}
    </div>
  );
};
